import React from "react";
import ReactCodeInput from "react-code-input";
import styles from "./Pin.module.css";

export const Pin = ({ onSubmit }: { onSubmit: (value: string) => void }) => {
  const onContinue = (value: string) => {
    if (value.length === 4) {
      onSubmit(value);
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.label}>Enter your PIN to continue</p>
      <div className={styles.pinContainer}>
        <ReactCodeInput
          className={styles.pin}
          inputMode="numeric"
          name="pin"
          type="number"
          onChange={onContinue}
          fields={4}
        />
      </div>
    </div>
  );
};
